export enum OccupiedStatus {
    Free = 'free',
    Occupied = 'occupied',
    Mine = 'mine',
    Locked = 'locked'
  }